import { render } from "./VueButton.vue?vue&type=template&id=2424c0e4&scoped=true"
import script from "./VueButton.vue?vue&type=script&lang=js"
export * from "./VueButton.vue?vue&type=script&lang=js"

import "./VueButton.vue?vue&type=style&index=0&id=2424c0e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2424c0e4"]])

export default __exports__